import React from 'react';
import './SFCVoteSlider.less';
import { IconFont } from '@src/features/common/Icon';
import { VoteQuestionPO } from '@src/services';

export interface ISFCVoteSliderProps {
  voteInfo?: VoteQuestionPO;
}
type Props = ISFCVoteSliderProps;

export function SFCVoteSlider(props: Props) {
  const { voteInfo = {} } = props;
  const redViewPort = (voteInfo.voteOptions && voteInfo.voteOptions[0]) || {};
  const blueViewPort = (voteInfo.voteOptions && voteInfo.voteOptions[1]) || {};

  const calc = (a: number, b: number) => {
    if (a === 0 && b === 0) {
      return 50;
    }
    if (a === 0 && b !== 0) {
      return 3;
    }
    if (a !== 0 && b === 0) {
      return 97;
    }
    return (a / (a + b)) * 100;
  };

  return (
    <div className="common-presenter k-common-vote-slider">
      <div className="vote-slider__info">
        <div className="vote-slider__info--item left">
          <div className="vote-slider__info--item--dot left" />
          <span>{redViewPort.voteDescription}</span>
          {voteInfo.colorIndex === redViewPort.color && <IconFont type="icon-icon-good" />}
        </div>
        <div className="vote-slider__info--item right">
          <div className="vote-slider__info--item--dot right" />
          <span>{blueViewPort.voteDescription}</span>
          {voteInfo.colorIndex === blueViewPort.color && <IconFont type="icon-icon-good" />}
        </div>
      </div>
      <div className="vote-slider__main">
        <div className="vote-slider__main--left">
          {redViewPort.voteCount}
          {(redViewPort.voteCount || redViewPort.voteCount === 0) && +redViewPort.voteCount <= 99
            ? '票'
            : ''}
        </div>
        <div className="vote-slider__main--slider">
          <div
            className="vote-slider__main--slider--left"
            style={{
              width: `${calc(redViewPort.voteCount || 0, blueViewPort.voteCount || 0)}%`
            }}
          />
          <div
            className="vote-slider__main--slider--right"
            style={{ width: `${calc(blueViewPort.voteCount || 0, redViewPort.voteCount || 0)}%` }}
          />
        </div>
        <div className="vote-slider__main--right">
          {blueViewPort.voteCount}
          {(blueViewPort.voteCount || blueViewPort.voteCount === 0) && +blueViewPort.voteCount <= 99
            ? '票'
            : ''}
        </div>
      </div>
    </div>
  );
}

export default SFCVoteSlider;
